// S2-0f.1-S2: Fetch single agent detail for the overview panel
import { useState, useEffect } from 'react';
import { apiFetch } from '../utils/api';
import type { AgentDetail } from '../types/eval';

export function useAgentDetail(agentId: string | null) {
  const [detail, setDetail] = useState<AgentDetail | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!agentId) {
      setDetail(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    apiFetch<AgentDetail>(`/v1/eval/agents/${agentId}`)
      .then((data) => {
        if (!cancelled) setDetail(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load agent detail');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [agentId]);

  return { detail, loading, error };
}
